import { DescriptionTheme } from 'src/general/components/MomentCirculation/themes/decription.theme';

import { CommonTheme } from './common.theme';

export const MomentCirculationTheme = {
  'MomentCirculation/common': CommonTheme,
  'MomentCirculation/description': DescriptionTheme,
};
